import {useEffect} from "react";
import {trackVisitor, startSession, endSession, trackPageView} from '~/helpers/TrackingVisitor';

const PublicRoute = ({ children }) => {
    useEffect(() => {
        let clientId, sessionId;
        (async () => {
            clientId = await trackVisitor();
            sessionId = await startSession(clientId);
             await trackPageView(clientId, sessionId);
        })();
        window.addEventListener("beforeunload", endSession)
        return ()=> window.removeEventListener("beforeunload", endSession);
    }, []);
    return children;
};

export default PublicRoute;
